var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.modificationHistory),function(row){return _c('li',[_c('history-row',{attrs:{"row":row}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }